import Vue from 'vue';
import { router } from './router';
import store from './store';
import App from './App.vue';
import 'vant/lib/icon/local.css';
import './common/css/reset.css';
router.afterEach((to,from,next)=>{
  window.scrollTo(0,0);
})
// import Vconsole from 'vconsole';

// let vConsole = new Vconsole();
// export default vConsole
// 引入http库
import axios from 'axios';
Vue.prototype.$axios = axios;

//按需引入vant组件库
import './common/js/vanCom';

/** 在微信中，授权时，会跳的微信授权的页面，locaction.href = https://open.weixin.qq.com/connect/oauth2/authorize ;
 * 但是，当授权过后，微信跳转到我们的页面的时候，该main文件没有再一次执行！！！(不知道是不是微信浏览器已经缓存了我们的页面的，而没有再次请求、执行我们的文件);
 * 所以Auth(),也没有执行，就拿不到cookie
 * 所以授权不要放在这里，放在router的beforeEach中
 */
//判断是否授权
// console.log('in main before run Auth!!');
//Auth();
// console.log('in main after run Auth');


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});






// WEBPACK FOOTER //
// ./src/main.js